import Vue from 'vue';

function getActiveSlugList(updatedList) {
  return updatedList.filter(obj => obj.active)
    .map(obj => obj.slug);
}

export default {
  state: {
    typeList: [
      // {
      //   label: '1 Bed',
      //   slug: 'one'
      //   active: false
      // }
    ],
    viewList: [
      {
        label: 'North',
        slug: 'n',
        active: false
      },
      {
        label: 'East',
        slug: 'e',
        active: false
      },
      {
        label: 'South',
        slug: 's',
        active: false
      },
      {
        label: 'West',
        slug: 'w',
        active: false
      },
    ],
    bathList: [
      // {
      //   label: '1',
      //   slug: '1',
      //   active: false
      // }
    ],
    sqftRange: {
      min: 0,
      max: 9999,
      default: {
        min: 0,
        max: 9999
      }
    },
    floorRange: {
      min: 0,
      max: 99,
      default: {
        min: 0,
        max: 99
      }
    },
    sortBy: {
      type: 'sqft',
      asc: true
    }
  },
  getters: {
    getFilters: state => state,
    activeTypes: state => state.typeList.filter(type => type.active).map(type => type.slug),
    activeViews: state => state.viewList.filter(view => view.active).map(view => view.slug),
    activeBaths: state => state.bathList.filter(bath => bath.active).map(bath => bath.slug),
    filtersTypes: state => state.typeList,
    filtersViews: state => state.viewList,
    filtersBaths: state => state.bathList,
    filtersSqftRange: state => state.sqftRange,
    filtersFloorRange: state => state.floorRange
  },
  actions: {
    SET_FLOOR_RANGE({ commit }, newFloorRange) {
      commit('setFloorRange', newFloorRange);
    },
    SET_SQFT_RANGE({ commit }, newSqftRange) { // newSize = { min: 0, max 99 }
      commit('setSqftRange', newSqftRange);
    },
    UPDATE_FILTERS_TYPES({ commit, rootState }, newTypes) {
      const projectId = rootState.project.adhocId;
      commit('updateTypes', { newTypes, projectId });
    },
    UPDATE_FILTERS_VIEWS({ commit, rootState }, newViews) {
      const projectId = rootState.project.adhocId;
      commit('updateViews', { newViews, projectId });
    },
    UPDATE_FILTERS_BATHS({ commit, rootState }, newBaths) {
      const projectId = rootState.project.adhocId;
      commit('updateBaths', { newBaths, projectId });
    }
  },
  mutations: {
    populateFilters(state, data) {
      state.floors = data.floors;
      // data.types.forEach((type) => {
      //   state.typeList.push({
      //     label: Parser.parseTypesLabel(type),
      //     slug: type,
      //     active: false
      //   });
      // });

      state.typeList = [
        {
          label: 'Studio',
          slug: 'studio',
          active: false
        },
        {
          label: '1 Bed',
          slug: 'one',
          active: false
        },
        {
          label: '1 Bed+Den',
          slug: 'oneDen',
          active: false
        },
        {
          label: '2 Bed',
          slug: 'two',
          active: false
        },
        {
          label: '2 Bed+Den',
          slug: 'twoDen',
          active: false
        },
        {
          label: '3 Bed',
          slug: 'three',
          active: false
        }
      ];

      state.bathList = [
        {
          label: '1',
          slug: '1',
          active: false
        },
        {
          label: '2',
          slug: '2',
          active: false
        }
      ];

      state.sqftRange = {
        min: data.sizes.min,
        max: data.sizes.max,
        default: {
          min: data.sizes.min,
          max: data.sizes.max
        }
      };

      const floorMin = parseInt(data.floors[data.floors.length - 1], 10);
      const floorMax = parseInt(data.floors[0], 10);
      state.floorRange = {
        min: floorMin,
        max: floorMax,
        default: {
          min: floorMin,
          max: floorMax
        }
      };
    },
    setFloorRange(state, newFloorRange) {
      state.floorRange.min = newFloorRange.min;
      state.floorRange.max = newFloorRange.max;
    },
    setSqftRange(state, newSqftRange) {
      state.sqftRange.min = newSqftRange.min;
      state.sqftRange.max = newSqftRange.max;
    },
    updateTypes(state, { newTypes, projectId }) {
      const activeTypes = getActiveSlugList(newTypes);
      Vue.ma.trackEvent({
        action: 'Filtered',
        properties: {
          project: projectId,
          type: 'Type',
          filteredList: activeTypes
        }
      });
      newTypes.forEach((newType, index) => {
        state.typeList[index].active = newType.active;
      });
    },
    updateViews(state, { newViews, projectId }) {
      const activeViews = getActiveSlugList(newViews);
      Vue.ma.trackEvent({
        action: 'Filtered',
        properties: {
          project: projectId,
          type: 'View',
          filteredList: activeViews
        }
      });
      newViews.forEach((newView, index) => {
        state.viewList[index].active = newView.active;
      });
    },
    updateBaths(state, { newBaths, projectId }) {
      const activeBaths = getActiveSlugList(newBaths);
      Vue.ma.trackEvent({
        action: 'Filtered',
        properties: {
          project: projectId,
          type: 'Baths',
          filteredList: activeBaths
        }
      });
      newBaths.forEach((newBath, index) => {
        state.bathList[index].active = newBath.active;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/Filters.js